import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { UserCog, ShieldCheck } from 'lucide-react'
import { PageHead } from '../AdminLayout'
import { Panel, DataTable, RefreshButton, Tag } from '../ui'
import { get } from '../../lib/api'
import { fa, faDate, asArray} from '../../lib/format'

const PERM_LABELS: Record<string, string> = {
  '*': 'دسترسی کامل',
  'users.read': 'مشاهده کاربران', 'users.write': 'ویرایش کاربران',
  'finance.read': 'مشاهده مالی', 'finance.write': 'عملیات مالی',
  'trading.read': 'مشاهده معاملات', 'trading.write': 'مدیریت معاملات',
  'kyc.read': 'مشاهده احراز هویت', 'kyc.write': 'بررسی احراز هویت',
  'chain.read': 'مشاهده زنجیره', 'chain.write': 'عملیات زنجیره',
  'content.write': 'مدیریت محتوا', 'support.write': 'پاسخ تیکت',
  'announce.write': 'اطلاعیه و پیام', 'staking.write': 'مدیریت استیکینگ',
  'settings.read': 'مشاهده تنظیمات', 'settings.write': 'تغییر تنظیمات',
  'logs.read': 'مشاهده گزارش‌ها', 'reports.read': 'مشاهده آمار',
}

export default function Staff() {
  const [rows, setRows] = useState<any[] | null>(null)
  const [roles, setRoles] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  const load = () => {
    setLoading(true)
    Promise.all([
      get('/admin/system/staff').then(setRows),
      get('/admin/system/roles').then((r: any) => setRoles(asArray(r))),
    ]).catch(() => setRows([])).finally(() => setLoading(false))
  }
  useEffect(load, [])

  return (
    <>
      <PageHead title="کارکنان و نقش‌ها" subtitle="فهرست کارکنان پنل و سطح دسترسی هر نقش"
        action={<RefreshButton onClick={load} loading={loading} />} />

      <Panel title="کارکنان" dense className="mb-5"
        action={<span className="text-[11px] text-slate-500">تغییر نقش از صفحه پرونده کاربر و توسط مالک سامانه انجام می‌شود</span>}>
        <DataTable rows={rows} loading={loading} minWidth={620} empty="کارمندی ثبت نشده است" columns={[
          { key: 'id', header: '#', cell: (r: any) => <span className="num text-slate-500">{fa(r.id)}</span> },
          { key: 'e', header: 'ایمیل', cell: (r: any) => <Link to={`/admin/users/${r.id}`} className="num text-brand-300 hover:underline" dir="ltr">{r.email}</Link> },
          { key: 'n', header: 'نام', cell: (r: any) => <span className="text-slate-200">{r.fullName || '—'}</span> },
          { key: 'r', header: 'نقش', cell: (r: any) => <Tag kind="gold">{r.roleLabel}</Tag> },
          { key: 'a', header: 'وضعیت', cell: (r: any) => r.isActive ? <Tag kind="up">فعال</Tag> : <Tag kind="down">غیرفعال</Tag> },
          { key: 'l', header: 'آخرین ورود', cell: (r: any) => <span className="text-slate-500">{r.lastLoginAt ? faDate(r.lastLoginAt) : '—'}</span> },
        ]} />
      </Panel>

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {roles.map((r) => (
          <Panel key={r.key} title={
            <div className="flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-brand-300" />
              <span className="font-bold text-white">{r.label}</span>
              <span className="num text-[10px] text-slate-500" dir="ltr">{r.key}</span>
            </div>
          }>
            <div className="flex flex-wrap gap-1.5">
              {r.perms.map((p: string) => (
                <span key={p} className="chip !py-1 text-[10px]">{PERM_LABELS[p] ?? p}</span>
              ))}
            </div>
          </Panel>
        ))}
      </div>
    </>
  )
}
